import React, { useMemo, memo } from 'react'
import styles from './StoresFilterViewStyles'
import { ScrollView, TouchableOpacity, View, Text } from 'react-native'
import theme from '../../../theme'
import { Feather } from '@expo/vector-icons'
import { TagsModel } from '../customUtils/Components/Models/TagsModel'

export const StoresFilterView = ({
    tags,
    onClickTag,
}: {
    tags: TagsModel[]
    onClickTag: (tag: TagsModel) => void
}) => {
    // Create a memoized, non-mutating sorted list to avoid re-renders caused by in-place sort
    const sortedTags = useMemo(() => {
        if (!tags) return []
        return [...tags].sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
    }, [tags])

    return (
        <View>
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                <View style={styles.container}>
                    {sortedTags.map((tag) => (
                        <StoreTagItem
                            key={tag._id ?? tag.title}
                            name={tag.title}
                            id={tag._id as any}
                            onClickTag={() => onClickTag(tag)}
                            isSelected={!!tag.isSelected}
                            value={tag.value}
                        />
                    ))}
                </View>
            </ScrollView>
        </View>
    )
}

export const StoreTagItem = memo(function StoreTagItem({
    name,
    id,
    onClickTag,
    isSelected,
    value,
}: {
    name: string
    id: number
    onClickTag: (tag: string, id: number) => void
    isSelected: boolean
    value?: number
}) {
    return (
        <View style={styles.containerLabels}>
            <TouchableOpacity
                onPress={() => onClickTag(name, id)}
                style={[
                    styles.flatFlagsPrimary,
                    {
                        backgroundColor: isSelected
                            ? theme.colors.colorPrimary
                            : 'white',
                    },
                ]}
            >
                <Text
                    style={
                        isSelected
                            ? styles.flatItemsSelectedPrimary
                            : styles.flatItemsUnselectedPrimary
                    }
                >
                    {name?.toString().toUpperCase() +
                        (value !== undefined && value != null ? ` (${value})` : '')}
                </Text>
            </TouchableOpacity>
        </View>
    )
})
